/* eslint-disable no-console -- this module is the single sanctioned console wrapper for the app */
/**
 * Frontend logging helper.
 *
 * Wraps the console so diagnostics stay available during development but are
 * suppressed in production builds — a shipped bundle should not narrate internal
 * failures (URLs, payload shapes, stack traces) into an end user's browser console.
 * User-facing failures are communicated via `toasterMsg`, not the console.
 */

const isDevelopment = process.env.NODE_ENV !== 'production';

/**
 * Log a handled error during development; no-op in production builds
 * @param message - Short description of the failing operation
 * @param details - Optional error object or structured context
 */
export function logError(message: string, ...details: unknown[]): void {
  if (isDevelopment) {
    console.error(message, ...details);
  }
}

/**
 * Log a warning during development; no-op in production builds
 * @param message - Short description of the recoverable condition
 * @param details - Optional error object or structured context
 */
export function logWarn(message: string, ...details: unknown[]): void {
  if (isDevelopment) {
    console.warn(message, ...details);
  }
}

export const logger = { error: logError, warn: logWarn };
export default logger;
